import { BackendSocket } from '../../hooks/use-socket';
import { SubscriberContext } from '../../hooks/use-backend';
import { BingoWinnerMessage } from '../../types/bingo-events/in/backend/winner-message';
import { meta, winners, current } from '../../stores/backend';

export const onWinnerMessage = (
    socket: BackendSocket,
    { payload, postBalanceChange }: SubscriberContext
) => {
    const callback = (data: BingoWinnerMessage) => {
        const parts = Object.keys(current.game_parts.value).length;

        const dataWinners = [...data.winners, ...(data.extraWinners || [])];

        payload.getAccountStatus();
        postBalanceChange('local-action');
        winners.gameSessionId.set(data.gameSessionId);
        winners.winners.merge(dataWinners);
        winners.consolationWinners.merge(data.consolationWinners);

        let isWinnerModalShown = false;

        if (current.game_continued.value === true) {
            isWinnerModalShown = true;
        } else {
            const latestWinnerPart = dataWinners.reduce(
                (result, winner) => Math.max(result, winner.part),
                0
            );
            current.current_part.set(latestWinnerPart - 1);
            isWinnerModalShown = latestWinnerPart === parts;
        }

        meta.modals.winner.set(isWinnerModalShown);
    };

    socket.on('bingo:winnerMessage', callback);

    return () => {
        socket.off('bingo:winnerMessage', callback);
    };
};
